enum TetturaActions {
    FETCH_LISTINGS = "tetturaFetchListings",
    REFRESH_LISTINGS = "tetturaRefreshListings",
    GET_LISTING = "tetturaGetListing",
    UPDATE_LISTING = "tetturaUpdateListing",
    UPDATE_LISTING_TRANSLATION = "tetturaUpdateListingTranslation",
    SET_LISTING_STATUS = "tetturaSetListingStatus",
    DELETE_LISTING = "tetturaDeleteListing",

    FETCH_ARCHITECTS = "tetturaFetchArchitects",
    REFRESH_ARCHITECTS = "tetturaRefreshArchitects",
    GET_ARCHITECT = "tetturaGetArchitect",
    UPDATE_ARCHITECT = "tetturaUpdateArchitect",
    UPDATE_ARCHITECT_TRANSLATION = "tetturaUpdateArchitectTranslation",
    SET_ARCHITECT_STATUS = "tetturaSetArchitectStatus",

    FETCH_REVIEWS = "tetturaFetchReviews",
    REFRESH_REVIEWS = "tetturaRefreshReviews",
    SET_REVIEW_STATUS = "tetturaSetReviewStatus",

    FETCH_ORDERS = "tetturaFetchOrders",
    REFRESH_ORDERS = "tetturaRefreshOrders",
    SET_ORDER_STATUS = "tetturaSetOrderStatus",

    FETCH_PAYOUTS = "tetturaFetchPayouts",
    PAY_ARCHITECT = "tetturaPayArchitect",
    EXPORT_SEPA = "tetturaExportSepa",

    FETCH_ACCOUNTS = "tetturaFetchAccounts",
    SET_ACCOUNT_STATE = "tetturaSetAccountState",
}

enum TetturaMutation {
    SET_LISTINGS_RESULT = "tetturaListingsResult",
    SET_ARCHITECTS_RESULT = "tetturaArchitectsResult",
    SET_REVIEWS_RESULT = "tetturaReviewsResult",
    SET_ORDERS_RESULT = "tetturaOrdersResult",
    SET_PAYOUTS_RESULT = "tetturaPayoutsResult",
    SET_ACCOUNTS_RESULT = "tetturaAccountsResult",
}

export { TetturaActions, TetturaMutation };
